import { Component, Input, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../../base/base.component';
import { WidgetService } from 'src/app/_services/review-services/widget.service';
import { subMonths, startOfMonth, subDays } from 'date-fns';
import { Subject, takeUntil } from 'rxjs';
import * as moment from 'moment';
import { PageEvent } from '@angular/material/paginator';
type ConfigureRangeDate = (current: Date) => boolean;

@Component({
  selector: 'app-users-performance',
  templateUrl: './users-performance.component.html',
  styleUrls: ['./users-performance.component.css']
})
export class UsersPerformanceComponent extends BaseComponent {
  @Input() isEdit: boolean = false;
  @Input() isVisible: boolean;
  @Input() chosenUser?: string;
  @Input() selectedReviewId: number;
  startDate: string;
  selectedTab: 'team' | 'client';
  endDate: string = new Date().toISOString();

  monitoringResponse: any;
  allDataFirst: any[] = [];
  currentPageDatafirst: any[] = [];
  totFirstTable: any;
  totAziendali: any;
  selectedProject: any;
  pageSizefirst = 10;
  currentPagefirst = 0;
  totalItemsfirst: number;
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktop: boolean = false;

  private readonly destroy$: Subject<void> = new Subject<void>();

  constructor(private readonly widgetService: WidgetService) {
    super();
    const twelveMonthsAgo: Date = subMonths(new Date(), 12);
    this.startDate = startOfMonth(twelveMonthsAgo).toISOString();
  }

  ngOnInit() {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 567) {
      this.isMobile = true;
      this.isTablet = false;
      this.isDesktop = false;
    } else if (screenWidth >= 567 && screenWidth <= 900) {
      this.isTablet = true;
      this.isMobile = false;
      this.isDesktop = false;
    } else {
      this.isTablet = false;
      this.isMobile = false;
      this.isDesktop = true;
    }

    this.selectedTab = 'team';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      this.isVisible &&
      (changes['chosenUser']?.currentValue || this.chosenUser) &&
      !!changes['selectedReviewId']?.currentValue
    ) {
      this.getMonitoring();
    }
  }

  getMonitoring() {
    const data = {
      chosenUser: this.chosenUser,
      selectedReviewId: this.selectedReviewId,
      start_date: moment(this.startDate).format('yyyy-MM-DD'),
      end_date: moment(this.endDate).format('yyyy-MM-DD')
    };

    this.widgetService
      .getMonitoring(data)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.monitoringResponse = res;
          if (this.selectedTab == 'team') {
            this.allDataFirst = res.Team;
            this.totFirstTable = res.totali_Team;
            this.totalItemsfirst = this.allDataFirst.length;
          } else if (this.selectedTab == 'client') {
            this.allDataFirst = res.Cliente;
            this.totFirstTable = res.totali_Cliente;
            this.totalItemsfirst = this.allDataFirst.length;
          }
          this.updateCurrentPageData();
        },
        error: (err: any) => {
          this.responseToast('error', err.message);
        }
      });
  }

  changeTab(tab: 'team' | 'client'): void {
    if (this.selectedTab == tab) return;
    else {
      this.selectedTab = tab;
      this.getMonitoring();
    }
  }

  onChange(): void {
    this.getMonitoring();
  }

  configureValideRangeForEndDate: ConfigureRangeDate = (
    current: Date
  ): boolean => {
    return new Date(this.startDate) > current || current > new Date();
  };

  configureValideRangeForStartDate: ConfigureRangeDate = (
    current: Date
  ): boolean => {
    return current > subDays(new Date(), 1);
  };

  onPageChange(event: PageEvent) {
    this.pageSizefirst = event.pageSize;
    this.currentPagefirst = event.pageIndex;
    this.updateCurrentPageData();
  }

  updateCurrentPageData() {
    const startIndex = this.currentPagefirst * this.pageSizefirst;
    const endIndex = Math.min(
      startIndex + this.pageSizefirst,
      this.allDataFirst.length
    );
    this.currentPageDatafirst = this.allDataFirst.slice(startIndex, endIndex);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
